<template>
    <div>
         <Carousel autoplay loop dots="none" :autoplay-speed="speed" :height="c_height" style="text-align:center;">
               <CarouselItem v-for="(item, index) in imgs" v-bind:key="index">
                    <div class="demo-carousel">
                         <img :src="item.path" style="height:inherit;width:auto;cursor:pointer;">
                    </div>
               </CarouselItem>
          </Carousel>
    </div>
</template>
<script>
    export default {
          props:['array','height'],
          data () {
               return {
                    value1: 0,
                    imgs:this.array,
                    c_height:this.height,
                    speed:5000
               }
          }
    }
</script>




// WEBPACK FOOTER //
// src/components/Carousel _style1.vue